var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "eyecatcher", staticClass: "ave__eyecatcher" },
    _vm._l(_vm.lines, function (line, i) {
      return _c(
        "div",
        {
          staticClass: "ave__eyecatcher__line",
          class: { "ave__eyecatcher__line--current": i === _vm.current },
        },
        [_vm._v("\n        " + _vm._s(line) + "\n    ")]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }